



















import { RightPackageSourceEnum, CallbackType } from '@/api/rights/types';
import URLUtils from '@/shared/utils/URLUtils';
import { defineComponent, onMounted, PropType } from '@vue/composition-api';
import { MembersRightsPrefix } from '@/constant';
import { MemberRouterNameEnum } from '@/shared/right-utils/routerName';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

export default defineComponent({
  name: 'EquityRecallBar',
  props: {
    /** 权益召回信息 */
    equityRecallInfo: {
      type: Object as PropType<CallbackType>,
      required: true,
    },
  },
  setup(props) {
    const onRightDetailClick = () => {
      // 查看权益详情
      const {
        capitalCode, sourceId, packageId, orderPayTyp,
      } = props.equityRecallInfo;

      /** 权益召回埋点(线上点位，暂不调整) */
      ubtSetupPageButton('finance_qualityHomePage_rightsCallBack', {
        callBackType: orderPayTyp === 'speed' ? 1 : 2,
        sourceId,
        packageId,
        from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
      });

      const rightsUrl = URLUtils.formatUrl(
        `${MembersRightsPrefix}${MemberRouterNameEnum.ZHENXIANG_CARD_API
        }.html#/${MemberRouterNameEnum.ZHENXIANG_CARD_API
        }`,
        {
          packageId,
          capitalCode,
          sourceId,
          from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
        },
      );

      // if (sourceId) {
      //   rightsUrl = URLUtils.formatUrl(
      //     `${MembersRightsPrefix}${MemberRouterNameEnum.ZHENXIANG_CARD_API
      //     }.html#/${MemberRouterNameEnum.ZHENXIANG_CARD_API
      //     }`,
      //     {
      //       packageId,
      //       capitalCode,
      //       sourceId,
      //       from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
      //     },
      //   );
      // } else {
      //   rightsUrl = URLUtils.formatUrl(
      //     `${MembersRightsPrefix}${MemberRouterNameEnum.ZHENXIANG_CARD
      //     }.html#/${MemberRouterNameEnum.ZHENXIANG_CARD
      //     }`,
      //     {
      //       packageId,
      //       capitalCode,
      //       from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
      //     },
      //   );
      // }
      /** 跳转使用新webview */
      jumpToNewVersion(rightsUrl, false);
    };

    onMounted(() => {
      const {
        sourceId, packageId, orderPayTyp,
      } = props.equityRecallInfo;

      ubtSetupModuleExpose(
        'finance_qualityHomePage_rightsCallBack',
        {
          callBackType: orderPayTyp === 'speed' ? 1 : 2,
          packageId,
          sourceId,
          from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
        },
      );
    });

    return {
      onRightDetailClick,
    };
  },
});
